import type { TermsState } from '@common/Checkout/Checkout/types';
import type { TermsReducer } from '@common/Checkout/Checkout/types/reducers';
import { SET_HAS_ACCEPTED_TERMS_AND_CONDITIONS, SET_HAS_TERMS_AND_CONDITIONS_ERROR } from '../actions/constants';

const initialState: TermsState = {
    hasAccepted: false,
    hasError: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: TermsReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case SET_HAS_ACCEPTED_TERMS_AND_CONDITIONS: {
            const { payload } = action;

            return { ...state, hasAccepted: payload };
        }

        case SET_HAS_TERMS_AND_CONDITIONS_ERROR: {
            const { payload } = action;

            return { ...state, hasError: payload };
        }

        default:
            return state;
    }
};

export default reducer;
